module.exports = __webpack_public_path__ + "img/esewa.7cc1c591.png";